export enum AttachmentStatus {
    empty = 0,
    added = 1,
    valid = 2,
    invalid = 3,
    uploaded = 4,
    Temporary = 5
}

export enum ErrorType {
    noError,
    maxSizeError,
    extensionError,
    multiErrors,
    uploadingError,
}